import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const Sidebar = () => {
  const sidebarLinks = [
    { name: 'Vision & Mission', url: 'https://davcommercesolapur.com/DAV/VisionMission.pdf', external: true },
    { name: 'Statutory Committees', url: '/statutory', external: false },
    { name: 'PO, PSO, CO & Graduate Attributes', url: 'https://davcommercesolapur.com/DAV/All%20PO,%20PSO%20andCOs%20all%20programme_updated.pdf', external: true },
    { name: 'NAAC Documents and SSR links', url: '/ssr', external: false },
    { name: 'Infrastructure & Facilities', url: '#', external: false },
    { name: 'Event Photo Gallery', url: '/gallery', external: false },
    { name: 'IPR Cell', url: '#', external: false },
    { name: 'College Committees', url: 'https://davcommercesolapur.com/DAV/College%20Committee_Final_2021-22.pdf', external: true },
    { name: 'Policies and Procedures', url: '/policy', external: false },
    { name: 'Scholarships', url: '#', external: false },
    { name: 'Placement Cell', url: '#', external: false },
    { name: 'Perspective plan', url: 'https://davcommercesolapur.com/DAV/CamScanner%2001-25-2022%2014.50.09.pdf', external: true },
    { name: 'Student Satisfaction survey', url: '/student', external: false },
    { name: 'Avishkar', url: 'https://davcommercesolapur.com/DAV/AVISHKAR%202020-2021.pdf', external: true },
    { name: 'Right To Information Act-2005 Declaration', url: 'https://davcommercesolapur.com/DAV/RTI.pdf', external: true },
    { name: 'ISO Certificate', url: 'https://davcommercesolapur.com/DAV/isocerificate.pdf', external: true },
    { name: 'Library', url: 'https://www.davcommercesolapur.org/DAV/library 2021.pdf', external: true },
    { name: 'AISHE', url: 'https://www.davcommercesolapur.org/DAV/AISHE CERTIFICATE C-15770-19-20.pdf', external: true },
    { name: 'Gallery', url: '/gallery', external: false }
  ];

  return (
    <div className="bg-[#FF4500] text-white">
      {/* Quick Links Heading */}
      <div className="bg-[#CC3700] px-4 py-4 border-b-2 border-white/30">
        <h2 className="text-xl font-bold text-center text-white">Quick Links</h2>
      </div>
      
      {/* Links */}
      {sidebarLinks.map((link, index) => (
        link.external ? (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block px-4 py-3 text-sm font-medium border-b border-white/20 hover:bg-[#FF5722] transition-colors duration-200 group"
          >
            <div className="flex items-center justify-between">
              <span>{link.name}</span>
              <ExternalLink className="w-3 h-3 opacity-70 group-hover:opacity-100" />
            </div>
          </a>
        ) : (
          <Link
            key={index}
            to={link.url}
            className="block px-4 py-3 text-sm font-medium border-b border-white/20 hover:bg-[#FF5722] transition-colors duration-200"
          >
            {link.name}
          </Link>
        )
      ))}
    </div>
  );
};

export default Sidebar;